import { PlanNameInput } from "../../PlanNameInput";
import { View } from "../../View";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  text: {
    fontSize: "12px",
    marginRight: "4px",
  },
  section: {
    marginTop: "20px",
  },
});

export const EditPlanModalContent = ({
  name,
  onNameChanged,
  setIsNameValid,
}) => {
  const styles = useStyles();

  return (
    <View>
      <View className={styles.section}>
        <View className={styles.inputContainer}>
          <PlanNameInput
            name={name}
            onChange={onNameChanged}
            setIsNameValid={setIsNameValid}
          />
        </View>
      </View>
    </View>
  );
};
